<template>
    <div class="countdown" v-show="countdownParts.length">
      <template v-for="(item, index) in countdownParts" :key="index">
          <div class="item">
              <p class="value">{{ item.value }}</p>
              <p class="label">{{ item.label }}</p>
          </div>
          <div class="colon" v-if="index < countdownParts.length - 1">:</div>
      </template>
    </div>
  </template>
  
  <script>
import { reactive, toRefs, watchEffect } from "vue";
  import { useI18n } from 'vue-i18n';
  
  export default {
    props: {
      endTime: {
          required: true,
        type: Number,
      },
      format: {
          type: String,
      }
    },
  
    setup(props) {
      const { t } = useI18n() 
  
      const state = reactive({
          countdownParts: [],
          timer: null,
          formateArr: ['D', 'h', 'm', 's']
      })

      watchEffect(() => {
        if(props.endTime) {
          getCountdownParts();
        }
      })
      function getCountdownParts() {
            var dateTxt = {
              D: t("date['D']"),
              h: t("date['h']"),
              m: t("date['m']"),
              s: t("date['s']"),
            }
          if(state.timer) {
              clearTimeout(state.timer);
          }
  
          let endTime = props.endTime;
          if(String(endTime).length < 13) {
            endTime = endTime * 1000;
          }
          // console.log("endTime",endTime);
          const format = props.format || 'D h m';
          const nowTime = new Date().getTime();
          var leftTime = endTime - nowTime;
          const formateArr = format.split(' ');
          const countdown = [];
          // console.log("leftTime",new Date(endTime), leftTime, endTime, nowTime);
          if(leftTime <= 0) {
            for (var i in formateArr) {
              countdown.push({
                    value: 0,
                    label: dateTxt[formateArr[i]]
                })
            }
          }else {
            const time = {
                'D': Math.floor(leftTime / 1000 / 60 / 60 / 24),
                'h': Math.floor(leftTime / 1000 / 60 / 60 % 24),
                'm': Math.floor(leftTime / 1000 / 60 % 60),
                's': Math.floor(leftTime / 1000 % 60)
            }
            for (var j in formateArr) {
              countdown.push({
                    value: time[formateArr[j]],
                    label: dateTxt[formateArr[j]]
                })
                // console.log("value: ",time[formateArr[j]]);
            }
            state.timer = setTimeout(function() {
              getCountdownParts();
            }, 10000)
          }
          // console.log('countdown:', countdown);

          state.countdownParts = countdown
          console.log('countdownParts:', state.countdownParts);
      }
      
      
      
  
      return {
          ...toRefs(state)
      }
    },
  };
  </script>
  
  <style lang="less" scoped>
  .countdown {
    display: flex;
    justify-content: center;
    .item {
      display: inline-block;
      vertical-align: top;
        border-radius: 5px;
        background-color: rgba(255, 255, 255, 0.5);
        color: #333;
        min-width: 60px;
        text-align: center;
        border: 1px solid rgba(255, 255, 255, 0.8);
        .value {
            font-size: 24px;
            font-weight: bold;
        }
        .label {
            color: @color_deep;
            border-top: 1px solid rgba(255, 255, 255, 0.8);
        }
    }
    .colon {
      margin: 0 10px;
      font-weight: bold;
      font-size: 24px;
      align-self: center;
      color: #666;
      animation: blink 1s linear infinite;
    }
  }

  @keyframes blink {
    50% { opacity: 0; }
  }

</style>
  